import request from '@/plugins/axios'

//获取系统配置
export function getSystemConfig(params) {
  return request({
    url: '/config/getSystemConfig/' + params,
    method: 'get'
  })
}

//删除系统配置
export function removeSystemConfig(params) {
  return request({
    url: '/config/removeSystemConfig/' + params,
    method: 'get'
  })
}

//设置系统配置
export function setSystemConfig(params,data) {
  return request({
    url: '/config/setSystemConfig/' + params,
    method: 'post',
    data
  })
}

//获取用户设置
export function getUserSetting(params1,params2) {
  return request({
    url: '/config/getUserSetting/' + params1 + '/' + params2,
    method: 'get'
  })
}

//删除用户设置
export function removeUserSetting(params1,params2) {
  return request({
    url: '/config/removeUserSetting/' + params1 + '/' + params2,
    method: 'get'
  })
}

//保存用户设置
export function setUserSetting(params1,params2,data) {
  return request({
    url: '/config/setUserSetting/' + params1 + '/' + params2,
    method: 'post',
    data
  })
}



//设置应用基础配置
export function setAppBaseConfig(data) {
  return request({
    url: '/config/setAppBaseConfig',
    method: 'post',
    data
  })
}

//获取应用基础配置
export function getAppBaseConfig() {
  return request({
    url: '/config/getAppBaseConfig',
    method: 'get'
  })
}

//设置文本与协议配置
export function setAppTextConfig(data) {
  return request({
    url: '/config/setAppTextConfig',
    method: 'post',
    data
  })
}

//获取文本与协议配置
export function getAppTextConfig() {
  return request({
    url: '/config/getAppTextConfig',
    method: 'get'
  })
}


//设置安全配置
export function setAppSecurityConfig(data) {
  return request({
    url: '/config/setAppSecurityConfig',
    method: 'post',
    data
  })
}

//获取安全配置
export function getAppSecurityConfig() {
  return request({
    url: '/config/getAppSecurityConfig',
    method: 'get'
  })
}

//获取站点配置
export function getWebSiteConfig() {
  return request({
    url: '/config/getWebsiteConfig', //getWebsiteConfig  
    method: 'get'
  })
}


//设置站点配置
export function setWebSiteConfig(data) {
  return request({
    url: '/config/setWebsiteConfig',
    method: 'post',
    data
  })
}


//获取单点登录配置
export function getSsoConfig() {
  return request({
    url: '/config/getSsoConfig',
    method: 'get'
  })
}

//设置单点登录配置
export function setSsoConfig(data) {
  return request({
    url: '/config/setSsoConfig',
    method: 'post',
    data
  })
}